import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import ProjectGallery from '../components/ProjectGallery';
import Loading from '../components/Loading';
import './ProjectDetail.css';
import './PortfolioDetail.css';

const PortfolioDetail = () => {
  const { slug } = useParams();
  const { getPortfolioItemBySlug, loading } = useData();
  const item = getPortfolioItemBySlug(slug);

  if (loading) {
    return <Loading />;
  }

  if (!item) {
    return (
      <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
        <h2>Lucrarea nu a fost găsită</h2>
        <Link to="/portfolio" className="btn">Înapoi la Portofoliu</Link>
      </div>
    );
  }

  return (
    <div className="portfolio-detail">
      <div className="container">
        {/* Simple Header */}
        <div className="simple-header">
          <Link to="/portfolio" className="back-link">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M10 18l-8-8 8-8 1.414 1.414L5.828 9H18v2H5.828l5.586 5.586z"/>
            </svg>
            Înapoi la Portofoliu
          </Link>
          
          <div className="title-section">
            <div className="title-left">
              <span className="category-tag">
                {item.category?.name || item.category_name || 'Portofoliu'}
              </span>
              <h1 className="page-title">{item.title}</h1>
              {item.type && <p className="type-info">📋 {item.type}</p>}
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="content-grid">
          {/* Left Column - Gallery + Description */}
          <div className="gallery-column">
            <ProjectGallery
              featuredImage={item.featured_image}
              images={item.images}
              title={item.title}
            />

            {/* Description */}
            <div className="description-section">
              <div className="description-header">
                <h2 className="description-title">Despre Lucrare</h2>
                <Link to="/contact" className="header-cta-button">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h14zm0 2H4v12h14V4zm-2 5l-6 4-6-4V7l6 4 6-4v2z"/>
                  </svg>
                  Contactează-ne
                </Link>
              </div>
              <div className="description-content">
                <p className="description-text">{item.description}</p>
              </div>
            </div>
          </div>

          {/* Right Column - Specifications */}
          <div className="info-column">
            {/* Specifications */}
            {item.specifications && item.specifications.length > 0 && (
              <div className="card specs-card">
                <h3 className="card-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2"/>
                    <line x1="9" y1="3" x2="9" y2="21" strokeWidth="2"/>
                  </svg>
                  Detalii
                </h3>
                <div className="specs-list">
                  {item.specifications.map(spec => (
                    <div key={spec.id} className="spec-item">
                      <span className="spec-label">{spec.label}</span>
                      <span className="spec-value">{spec.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioDetail;

